export enum UserStateProviderActionType {
  'SET_USER_ID',
  'SET_USER_TOKEN',
  'SET_USER_EMAIL',
  'RESET_STATE',
}
